// import AuthServiceFactory from '@/services/auth/AuthServiceFactory'
import { DIALOG_CONFIRM } from './types'
import store from '@/store'
import i18n from '@/i18n'

// const authService = AuthServiceFactory.getInstance()

export const DIALOG_LOGOUT = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.logout'),
    buttonLabelAffirmative: 'YES',
    // buttonActionAffirmative: () => authService.logout.logout(),
    buttonLabelNegative: 'NO',
    class: 'centerModalText'
  }
}

export const DIALOG_CONFIRM_CREATE = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.confirmCreate'),
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO'
  }
}

export const DIALOG_CONFIRM_SAVE = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.confirmSave'),
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO'
  }
}

export const DIALOG_CONFIRM_DELETE = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.confirmDelete'),
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO'
  }
}

export const DIALOG_CONFIRM_CANCEL = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.confirmCancel'),
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO',
    class: 'centerModalText'
  }
}

export const DIALOG_DONE = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.information'),
    text: i18n.t('dialogs.text.done'),
    buttonLabelAffirmative: i18n.t('buttons.ok'),
    buttonActionAffirmative: () => {
      store.dispatch('ui/closeDialog')
    },
    buttonLabelNegative: '',
    class: 'centerModalText'
  }
}

export const DIALOG_SERVER_ERROR = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.error'),
    error: true,
    text: i18n.t('validations.serverError'),
    buttonLabelAffirmative: i18n.t('buttons.accept'),
    buttonLabelNegative: ''
  }
}

export const DIALOG_ERROR = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.error'),
    text: i18n.t('dialogs.text.error'),
    buttonLabelAffirmative: i18n.t('buttons.ok'),
    buttonActionAffirmative: () => {
      store.dispatch('ui/closeDialog')
    },
    buttonLabelNegative: '',
    class: 'centerModalText'
  }
}
export const DIALOG_SINDATOS = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.alert'),
    text: i18n.t('dialogs.text.noData'),
    buttonLabelAffirmative: i18n.t('buttons.ok'),
    buttonActionAffirmative: () => {
      store.dispatch('ui/closeDialog')
    },
    buttonLabelNegative: ''
  }
}

export const DIALOG_CONFIRM_CHANGE_GRPC = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: i18n.t('dialogs.text.changeGrpc'),
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO',
    buttonActionNegative: null
  }
}

export const DIALOG_SAVED_ATTACHMENTTYPE_SUCCESS = {
  component: DIALOG_CONFIRM,
  props: {
    title: 'ÉXITO',
    text: 'Tipo de documentación guardado correctamente',
    buttonLabelAffirmative: 'YES',
    buttonLabelNegative: '',
    buttonActionAffirmative: () => {
      store.dispatch('ui/closeDialog')
      document.getElementById('dataSearchButton').click()
    }
  }
}

export const DIALOG_CONFIRM_EDITRAN = {
  component: DIALOG_CONFIRM,
  props: {
    title: i18n.t('dialogs.title.confirmation'),
    text: '',
    buttonLabelAffirmative: 'YES',
    buttonActionAffirmative: null,
    buttonLabelNegative: 'NO'
  }
}

export const DIALOG_SAVED_ATTACHMENTTYPE_OTHER = {
  component: DIALOG_CONFIRM,
  props: {
    title: 'WARNING',
    text: 'Ha ocurrido un problema',
    buttonLabelAffirmative: 'YES',
    buttonLabelNegative: '',
    buttonActionAffirmative: () => {
      store.dispatch('ui/closeDialog')
      document.getElementById('dataSearchButton').click()
    }
  }
}

export const DIALOG_UNEXPORTED_LIMIT_ROWS = {
  component: DIALOG_CONFIRM,
  props: {
    title: 'CUIDADO',
    warning: true,
    text: 'Los resultados de la búsqueda son mayores a 60.000 registros.',
    buttonLabelAffirmative: 'Entendido',
    buttonLabelNegative: ''
  }
}
